// Mock data for Producers Today guest application

export const STATS = [
  { value: '6.8B+', label: 'Total Platform Users' },
  { value: '4', label: 'Podcast Platforms' },
  { value: '14+', label: 'TV Platforms' },
  { value: 'FREE', label: 'No Cost to Appear' },
];

export const WHY_FEATURES = [
  {
    icon: 'Mic',
    title: 'Massive Podcast Reach',
    desc: "Your episode distributed to Apple Podcasts, iHeart Radio, Spotify, and Amazon Music, reaching over 903 million combined listeners worldwide.",
  },
  {
    icon: 'Tv',
    title: 'Annuity TV Distribution',
    desc: "Your annuity story broadcast across 14+ smart TV and streaming platforms including Roku, Samsung, LG, Apple TV, Amazon Fire TV, Google Play, iOS, and more.",
  },
  {
    icon: 'Globe',
    title: 'Global Authority',
    desc: "Position yourself as a trusted annuity expert with a feature in Producers Today, The Voice of the Producers. Reach clients across the globe at no cost, ever.",
  },
];

// slug = simpleicons.org slug; color = brand color hex used as background tint
// customIcon: optional URL or data-URI for an official logo image (takes priority)
export const PODCAST_PLATFORMS = [
  { name: 'Apple Podcasts', users: '28.5M Users', color: '#8E44EC', slug: 'applepodcasts' },
  { name: 'iHeart Radio',   users: '167M Users',  color: '#C6002B', slug: 'iheartradio' },
  { name: 'Spotify',        users: '626M Users',  color: '#1DB954', slug: 'spotify' },
  {
    name: 'Amazon Music',
    users: '82.2M Users',
    color: '#25D1DA',
    customIcon: 'https://yt3.googleusercontent.com/vXVNL_IU8NxwsJ4GpdX3yJW2R5nwVhJoYBXz96VpGsiaBWtOwj59IL4S5O3YuoQQAMArOpizpg=s900-c-k-c0x00ffffff-no-rj',
  },
];

export const TV_PLATFORMS = [
  { name: 'iOS',             users: '1.46B Users',  color: '#A6A6A6', slug: 'apple', iconColor: 'A6A6A6' },
  {
    name: 'Google Play',
    users: '2.6B Users',
    color: '#34A853',
    customIcon: 'https://upload.wikimedia.org/wikipedia/commons/d/d0/Google_Play_Arrow_logo.svg',
  },
  { name: 'Samsung',         users: '535M Users',   color: '#1428A0',
    customIcon: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 600 150'%3E%3Crect width='600' height='150' fill='%23ffffff' /%3E%3Ctext x='300' y='110' text-anchor='middle' font-family='Arial Black, Arial, sans-serif' font-weight='900' font-size='100' fill='%231428A0' letter-spacing='5'%3ESAMSUNG%3C/text%3E%3C/svg%3E",
  },
  {
    name: 'Android TV',
    users: '270M Users',
    color: '#3DDC84',
    customIcon: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'%3E%3Crect x='10' y='18' width='80' height='58' rx='4' fill='%237C8893' /%3E%3Crect x='15' y='23' width='70' height='48' fill='%23383B3F' /%3E%3Crect x='40' y='76' width='20' height='5' fill='%237C8893' /%3E%3Crect x='25' y='81' width='50' height='5' rx='2' fill='%237C8893' /%3E%3Cpath d='M 25,65 A 25,25 0 0,1 75,65 Z' fill='%233DDC84' /%3E%3Ccircle cx='40' cy='50' r='3.5' fill='%23383B3F' /%3E%3Ccircle cx='60' cy='50' r='3.5' fill='%23383B3F' /%3E%3Cline x1='35' y1='35' x2='25' y2='25' stroke='%233DDC84' stroke-width='3.5' stroke-linecap='round' /%3E%3Cline x1='65' y1='35' x2='75' y2='25' stroke='%233DDC84' stroke-width='3.5' stroke-linecap='round' /%3E%3C/svg%3E",
  },
  { name: 'Roku',            users: '83.7M Users',  color: '#662D91', slug: 'roku', iconColor: '662D91' },
  {
    name: 'Amazon Fire TV',
    users: '50M Users',
    color: '#FC4C02',
    customIcon: 'https://play-lh.googleusercontent.com/5u3NrqtmIQmpHG8e2bgsiunhPAZnyBaXNfu-kpV-P835gP8AOS4TGptUsu0lgBqQJxOb',
  },
  { name: 'Apple TV',        users: '32M Users',    color: '#A6A6A6', slug: 'appletv', iconColor: 'A6A6A6' },
  { name: 'LG webOS',        users: '200M Users',   color: '#A50034', slug: 'lg', iconColor: 'A50034' },
  {
    name: 'Panasonic',
    users: '300M Users',
    color: '#0F47AF',
    customIcon: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 600 150'%3E%3Crect width='600' height='150' fill='%2322529D' /%3E%3Ctext x='300' y='105' text-anchor='middle' font-family='Arial, Helvetica, sans-serif' font-weight='bold' font-size='100' fill='%23ffffff' letter-spacing='-1'%3EPanasonic%3C/text%3E%3C/svg%3E",
  },
  { name: 'Sony',            users: '33.3M Users',  color: '#CCCCCC', slug: 'sony', iconColor: 'CCCCCC' },
  {
    name: 'TCL',
    users: '25.6M Users',
    color: '#CA3532',
    customIcon: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'%3E%3Crect width='100' height='100' fill='%23CA3532' /%3E%3Ctext x='50' y='55' text-anchor='middle' font-family='Arial Black, Arial, sans-serif' font-weight='900' font-size='38' fill='%23ffffff'%3ETCL%3C/text%3E%3Ctext x='50' y='80' text-anchor='middle' font-family='Arial, sans-serif' font-weight='bold' font-size='18' fill='%23ffffff' letter-spacing='-0.5'%3ECHANNEL%3C/text%3E%3C/svg%3E",
  },
  {
    name: 'Philips',
    users: '100M Users',
    color: '#0066A1',
    customIcon: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 560 150'%3E%3Ctext x='280' y='115' text-anchor='middle' font-family='Arial Black%2C Arial%2C sans-serif' font-weight='900' font-size='108' fill='%231A6FD4'%3EPHILIPS%3C/text%3E%3C/svg%3E",
  },
  {
    name: 'Sharp',
    users: '25M Users',
    color: '#E60012',
    customIcon: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 600 150'%3E%3Crect width='600' height='150' fill='%23E60012' /%3E%3Ctext x='290' y='105' text-anchor='middle' font-family='Arial Black, Arial, sans-serif' font-weight='900' font-size='90' fill='%23ffffff' letter-spacing='5'%3ESHARP%3C/text%3E%3Ctext x='470' y='105' font-family='Arial, sans-serif' font-weight='bold' font-size='25' fill='%23ffffff'%3E%C2%AE%3C/text%3E%3C/svg%3E",
  },
  {
    name: 'Amazon Appstore',
    users: '300M Users',
    color: '#FF9900',
    customIcon: 'https://m.media-amazon.com/images/G/01/hollywood/LandingPages/AppstoreTileIcon_BrightBlue_RGB.png',
  },
];

export const INDUSTRY_TYPES = [
  'Fixed Indexed Annuities (FIA)',
  'Multi-Year Guaranteed Annuities (MYGA)',
  'Single Premium Immediate Annuities (SPIA)',
  'Variable Annuities / Registered Index-Linked (RILA)',
  'Life Insurance (IUL, Whole Life, Term)',
  'Property & Casualty (P&C)',
  'Commercial / Business Insurance',
  'Medicare Coverage',
  'Retirement Income Planning',
  'Asset Management / Wealth Management',
  'Trust / Estate & Tax Planning',
  'Health & Group Benefits',
  'Other',
];

export const AUDIENCE_REACH = [
  'Under $1 Million',
  '$1M – $3 Million',
  '$3M – $5 Million',
  '$5M – $10 Million',
  '$10M+',
];

export const TIME_SLOTS = [
  '9:00 AM', '10:00 AM', '11:00 AM',
  '1:00 PM', '2:00 PM', '3:00 PM', '4:00 PM', '5:00 PM',
];

export const countries = [
  "United States",
  "Canada",
  "United Kingdom",
  "Australia",
  "India",
  "Germany",
  "France",
  "Spain",
  "Italy",
  "Brazil",
  "Mexico",
  "Japan",
  "South Korea",
  "Other",
];

